import React from 'react';
import { Navigate } from 'react-router-dom';
import { PageShell } from '../components/PageShell';
import { ChevronHeading } from '../components/ChevronHeading';
import { useSession } from '../contexts/SessionContext';
import { dashboardPanels } from '../data/site';
export function Dashboard() {
  const {
    isLoggedIn
  } = useSession();
  if (!isLoggedIn) return <Navigate to="/login?redirect=/dashboard" replace data-id="element-266" data-mp="yrg0aj455uqd" />;
  return <PageShell championBannerLayout="fullBleed" data-id="element-267" data-mp="b0k6jgg4kpgh">
      <section className="px-6 py-10 text-center" data-id="element-268" data-mp="60xpsx138r2x">
        <ChevronHeading as="h1" size="lg" data-id="element-269" data-mp="628ssumplusz">Member Dashboard</ChevronHeading>
        <p className="mt-6 text-lg font-semibold" data-id="element-270" data-mp="ky88aqc5ex85">Your schedule isn’t ready just yet, please check back later.</p>
      </section>
      <section className="bg-[#EEEEF0] px-6 py-8 text-center" data-id="element-271" data-mp="fxalg0g71f0b">
        <ChevronHeading data-id="element-272" data-mp="1wcc1vvetqjco">Upcoming Games</ChevronHeading>
        <p className="py-10 text-xl font-semibold" data-id="element-273" data-mp="1weya7x9jh2vy">No upcoming games for the next 10 days</p>
      </section>
      <section className="grid gap-12 px-6 py-8 md:grid-cols-3 lg:px-14" data-id="element-274" data-mp="1rgdbk29xqr9m">
        {dashboardPanels.map(p => <article key={p.title} className="flex flex-col bg-[#EEEEF0] p-6" data-id="element-275" data-mp="26oht4k4n101x">
            <ChevronHeading as="h3" size="sm" data-id="element-276" data-mp="26qksvvvle7ju">{p.title}</ChevronHeading>
            <p className="mt-8 text-[17px]" data-id="element-277" data-mp="2bochoh0xxdjt">{p.body}</p>
          </article>)}
      </section>
    </PageShell>;
}